function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Error from "next/error";
import DynamicTemplate from "components/templates/dynamic-template/dynamic-template";
import { fetchDynamicSegmentsRequestFromServer, getFaqData } from "utils/dynamicPage";
import { getSegmentsDynamicsFetchMapper } from "components/templates-generator/config";
import BaseTemplatePage, { getServerSideProps as getBaseProps } from "./base-template-page";
const getDynamicData = function() {
    var _ref = _async_to_generator(function*({ superInitialProps, req, res, query }) {
        const { pageConfig } = superInitialProps;
        let data = {};
        if (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.template) {
            const segmentsDynamicsFetchMapper = getSegmentsDynamicsFetchMapper(pageConfig.template);
            const { dynamicData } = yield fetchDynamicSegmentsRequestFromServer({
                pageConfig,
                segmentsDynamicsFetchMapper,
                req,
                res,
                query
            });
            data = dynamicData;
        }
        return data;
    });
    return function getDynamicData(_) {
        return _ref.apply(this, arguments);
    };
}();
const setFaqSeoData = ({ superInitialProps, req, res })=>{
    const { pageConfig } = superInitialProps;
    if (pageConfig) {
        const seoFAQ = getFaqData({
            pageConfig,
            res,
            req
        });
        if ((seoFAQ === null || seoFAQ === void 0 ? void 0 : seoFAQ.length) > 0) {
            pageConfig.seoFAQ = seoFAQ;
        }
    }
};
export function getServerSideProps(context) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = _async_to_generator(function*(context) {
        const baseProps = yield getBaseProps(context);
        const superInitialProps = baseProps.props;
        superInitialProps.forcePricing = superInitialProps.forcePricing || null;
        setFaqSeoData({
            req: context.req,
            res: context.res,
            superInitialProps
        });
        // Ensure prior errors are respected
        if (superInitialProps.errorCode) {
            return baseProps;
        }
        const dynamicData = yield getDynamicData({
            req: context.req,
            res: context.res,
            query: context.query,
            superInitialProps
        });
        return {
            props: _object_spread_props(_object_spread({}, superInitialProps), {
                dynamicData
            })
        };
    });
    return _getServerSideProps.apply(this, arguments);
}
class DynamicTemplatePage extends BaseTemplatePage {
    render() {
        const { errorCode } = this.props;
        if (errorCode) return /*#__PURE__*/ _jsx(Error, {
            statusCode: errorCode
        });
        return /*#__PURE__*/ _jsx(DynamicTemplate, _object_spread({}, this.props));
    }
}
export { DynamicTemplatePage as default };
